import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {useGlobals} from '../../../../../../globalPropsContext';
import {isPurchaseUnavailable} from '../../../productItemUtils';

export const useAddToCartText = (productId: string, hasAddToCartUnselectedOptionError: boolean) => {
  const {textsMap, productsManifest} = useGlobals();
  const {addToCartState} = productsManifest[productId];
  const {
    addToCartContactSeller,
    addToCartOutOfStock,
    productUnavailableText,
    selectOptionsButtonText,
    galleryAddToCartPreOrderButtonText,
    galleryAddToCartButtonText,
  } = textsMap;

  if (addToCartState === AddToCartState.DISABLED) {
    return addToCartContactSeller;
  }

  if (isPurchaseUnavailable(productsManifest[productId])) {
    return productUnavailableText;
  }

  if (addToCartState === AddToCartState.OUT_OF_STOCK) {
    return addToCartOutOfStock;
  }

  if (hasAddToCartUnselectedOptionError) {
    return selectOptionsButtonText;
  }

  if (addToCartState === AddToCartState.PRE_ORDER) {
    return galleryAddToCartPreOrderButtonText;
  }

  return galleryAddToCartButtonText;
};
